import React from 'react';
import imgUrbanIcon from '../../../assets/PNG/urban_icon.png';
import * as S from './loadingStyles';

export const Loading = ({ text = 'Loading...', showLogo = true }) => {
  return (
    <S.LoadingContainer>
      <S.LoadingContent>
        <S.SpinnerContainer>
          <S.Spinner />
          {showLogo && (
            <S.LogoWrapper>
              <img src={imgUrbanIcon} alt="Loading" />
            </S.LogoWrapper>
          )}
        </S.SpinnerContainer>

        <S.LoadingText>{text}</S.LoadingText>
      </S.LoadingContent>
    </S.LoadingContainer>
  );
};
